document.addEventListener('DOMContentLoaded', function() {

  /**
   * If product bundle not entire, remove products
   */

  // === Check if cart contains bundle items to remove
  async function fetchAndUpdateCart() {
    try {
      // Get cart
      const response = await fetch('/cart.js');
      const cart = await response.json();
  
      let itemsToRemove = [];

      if (cart.items.length > 0) {

        // Get items to remove
        cart.items.forEach(item => {
          if (item.properties && item.properties['_bundle_id']) {
            const bundleId = item.properties['_bundle_id'];
            const bundleLength = parseInt(item.properties['_bundle_length'], 10);
    
            // Similar item count
            const bundleItemsCount = cart.items.filter(item => item.properties && item.properties['_bundle_id'] === bundleId).length;
    
            // If bundle not entire
            if (bundleItemsCount < bundleLength) {
              itemsToRemove = [...itemsToRemove, ...cart.items.filter(item => item.properties && item.properties['_bundle_id'] === bundleId).map(item => item.id)];
            }
          }
        });
    
        // Remove duplicates items 
        itemsToRemove = [...new Set(itemsToRemove)];
    
        // Update cart
        if (itemsToRemove.length > 0) {
          await updateCart(itemsToRemove);
        }

      }
  
    } catch (error) {
      console.error('Error retrieving or updating cart:', error);
    }
  }
  
  // === Update cart
  async function updateCart(itemsToRemove) {
    try {
      const updates = itemsToRemove.reduce((obj, itemId) => {
        obj[itemId] = 0; // Set quantity to 0 for deleted items
        return obj;
      }, {});
  
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });
      
      if (response.ok) {
        if (window.location.href.indexOf('/cart') > -1) {
          window.location.reload();
        } else {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.handleCartUpdates();
          }
        }
      }
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }

  // === Detect cart interactions
  const originalFetch = window.fetch;
  window.fetch = function() {
      return originalFetch.apply(this, arguments).then(response => {
          // --- Check if url contains cart add/change/update
          if (response.url.includes('/cart/add') || response.url.includes('/cart/change') || response.url.includes('/cart/update')) {
            fetchAndUpdateCart();
          }
          return response;
      });
  };

});